

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      //event.preventDefault();
      //this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

// Discount logics added here
async function updateCartDiscounts() {
    const code = document.querySelector('#discount_code')?.value;
    if (code) {
      let response = await fetch('/cart.js');
      let data = await response.json();
      await calculateCartDiscounts(data, code);
    }
  }

  async function mobileUpdateCartDiscounts() {
    const code = document.querySelector('#discount_code_mobile')?.value;
    if (code) {
      let response = await fetch('/cart.js');
      let data = await response.json();
      await calculateCartDiscounts(data, code);
    }
  }

  async function calculateCartDiscounts(data, code) {
    if (data.items) {
      const payload = {
        cart: data,
        code: code,
      };
      const response = await fetch('/a/shipping/coupon', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(payload),
      });
      const responseData = await response.json();
      let isValid = false;
      let isFreeShippingValid = false;
      let lineTotalAfterDiscount = responseData.total;
      let lineTotal = responseData.subtotal;
        lineTotal = lineTotal.toFixed(2);
        lineTotalAfterDiscount = lineTotalAfterDiscount.toFixed(2);
      if (typeof responseData.discountCodes === 'undefined') {
        //setCouponMessage("An error occurred applying the coupon code");
      } else {
        responseData.discountCodes.forEach((discountCode) => {
          if (discountCode.code == code) {
            isValid = discountCode.applicable;
          }
        });
        if (responseData.freeShippingData && responseData.freeShippingData.codeApplies) {
          if (responseData.total > responseData.freeShippingData.minimumRequirement) {
            isFreeShippingValid = true;
            //TODO: Set free shipping applied message
          }
        }
        if (!isValid && !isFreeShippingValid) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { discount_code: null } }),
          });
          document.querySelector('.line-error.mb').classList.remove('hide');
          document.querySelector('.line-error.dk').classList.remove('hide');
          document.querySelector('.discount-tag.dk').classList.add('hide');
          document.querySelector('.discount-tag.mb').classList.add('hide');

          // Select all buttons with the class 'discount-remove-button'
           const buttons = document.querySelectorAll('button.discount-remove-button');

          // Loop through each button and trigger the click event
          buttons.forEach(button => {
            // Create and dispatch a click event
            const clickEvent = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            });

            // Dispatch the click event on the button
            button.dispatchEvent(clickEvent);
          });
        } else {
          document.querySelector('.data-cart-subtotal').innerHTML = '$' + lineTotalAfterDiscount;
          document.querySelector('.data-cart-subtotal-discounted').innerHTML = '$' + lineTotal;

          var secondSpan = document.querySelector('.subtotal-top span:nth-child(2)');
          if (secondSpan) {
            secondSpan.innerHTML = '$' + lineTotalAfterDiscount;
          }

          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { discount_code: code } }),
          });
          document.querySelector('.line-error.dk').classList.add('hide');
          document.querySelector('.line-error.mb').classList.add('hide');
          document.querySelector('.discount-code-text.mb').innerHTML = code;
          document.querySelector('.discount-code-text.dk').innerHTML = code;
          document.querySelector('.discount-tag.dk').classList.remove('hide');
          document.querySelector('.discount-tag.mb').classList.remove('hide');

              setTimeout(function(){
                  fetch(window.Shopify.routes.root + `discount/${code}`,{method: 'GET',headers: {'Content-Type':'application/json'}});
              }, 1500);

              let cart_items = responseData.items;
              // cart_items.reverse();
              let cartFixedAmt = responseData.cartDiscount;
              if (cart_items.length > 0 && cartFixedAmt <=0) {
                for (let i = 0, cnt = 1; i < cart_items.length; i++, cnt++) {
                    const cart_line_original_price = cart_items[i].subtotal;
                    const cart_line_discounted_price = cart_items[i].total;

                    if (cart_line_original_price > cart_line_discounted_price) {
                        const newpriceHTML = `<dl class='cart-item__discounted-prices'>
                            <dt class='visually-hidden'>Regular price</dt>
                            <dd><s class='cart-item__old-price price price--end'>$${cart_line_original_price.toFixed(2)}</s></dd>
                            <dt class='visually-hidden'>Sale price</dt>
                            <dd class='price price--end'>$${cart_line_discounted_price.toFixed(2)}</dd></dl>`;

                        const cartPriceItems = document.querySelectorAll(`#CartItem-${cnt} .cart-item__price-wrapper`);

                        if (cartPriceItems.length >= 2) {
                            cartPriceItems[1].innerHTML = newpriceHTML;
                        }
                    }
                }
             }
             else if(cartFixedAmt > 0){
               const fixedcodeHTML = `<div><ul class="discounts list-unstyled" role="list" aria-label="Discount">
              <li class="discounts__discount discounts__discount--position"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
              </svg>${code}(-$${cartFixedAmt.toFixed(2)})</li></ul></div>`;

                document.querySelector('.cartFixedWrapper').innerHTML = fixedcodeHTML;
             }

        }
      }
    }
  }


  // Apply discount code logic for cart page
  document.querySelectorAll('button.apply-discount-code.desktop').forEach((button) => {
    button.addEventListener('click', async () => {
      updateCartDiscounts();
    });
  });

  document.querySelectorAll('button.apply-discount-code.mobile').forEach((button) => {
    button.addEventListener('click', async () => {
      mobileUpdateCartDiscounts();
    });
  });

  updateCartDiscounts();
  mobileUpdateCartDiscounts();

  // Remove discount code logic
  document.querySelectorAll('button.discount-remove-button').forEach((button) => {
    button.addEventListener('click', async () => {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { discount_code: null } }),
      });
      document.querySelector('.discount-tag.dk').classList.add('hide');
      document.querySelector('.discount-tag.mb').classList.add('hide');
      document.querySelector('#discount_code_mobile').value = '';
      document.querySelector('#discount_code').value = '';
      /*document.querySelector('.data-cart-subtotal').innerHTML = document.querySelector(
        '.data-cart-subtotal-discounted'
      ).innerHTML;*/
      const discountedSubtotal = document.querySelector('.data-cart-subtotal-discounted');
      const cartSubtotal = document.querySelector('.data-cart-subtotal');
      if (discountedSubtotal && discountedSubtotal.innerHTML.trim() !== '') {
        cartSubtotal.innerHTML = discountedSubtotal.innerHTML;
      }

      //document.querySelector('.data-cart-subtotal-discounted').innerHTML = '';
      if (discountedSubtotal && discountedSubtotal.innerHTML.trim() !== '') {
        document.querySelector('.subtotal-top span:nth-child(2)').innerHTML = document.querySelector(
            '.data-cart-subtotal-discounted'
        ).innerHTML;
      }

      document.querySelector('.data-cart-subtotal-discounted').innerHTML = '';
      document.querySelector('.cartFixedWrapper').innerHTML = '';

            let code=0;
            setTimeout(function(){
                fetch(window.Shopify.routes.root + `discount/${code}`,{method: 'GET',headers: {'Content-Type':'application/json'}});
            }, 1000);

            const oldPriceElements = document.querySelectorAll('.cart-item .cart-item__price-wrapper .cart-item__old-price');
            if (oldPriceElements.length > 0) {
              oldPriceElements.forEach((element, index) => {
                  const oldPriceValue = element.innerText;
                  const parentElement = element.closest('.cart-item__price-wrapper');
                  if (parentElement) {
                      parentElement.innerHTML = "<span class='price price--end'>"+oldPriceValue+"</span>";
                  }
              });
            }

    });
  });

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target.getAttribute('name') === 'updates[]') {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.main-cart-items',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
  
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: parsedState
          }
        }));
        
        if(document.querySelector(".close-form-message")){
          document.querySelector(".close-form-message").addEventListener("click", (e) => {
          document.querySelector(".form__message").classList.add("close-fade-out");
          setTimeout(function(){
            document.querySelector(".form__message.close-fade-out").classList.add("hide");
          },700);
        });
        }
        
        this.updateLiveRegions(line, parsedState.item_count);
        
        const lineItem =  document.getElementById(`CartItem-${line}`);
        
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        
        this.disableLoading();

        setTimeout(function () {
          updateCartDiscounts();
          mobileUpdateCartDiscounts();
        }, 600);
        
        /* Dispatch new event for cart update */
  
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
     
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);
